import { jsxs as t, jsx as i } from "react/jsx-runtime";
import { svgIconStyles as n } from "../svg-icon/SvgIcon.styles.js";
function C({
  label: s,
  className: e,
  size: o,
  ...r
}) {
  return /* @__PURE__ */ t(
    "svg",
    {
      viewBox: "0 0 24 24",
      fill: "none",
      "data-title": "dismiss",
      stroke: "none",
      role: "img",
      "aria-hidden": !s,
      focusable: "false",
      className: n({ className: e, size: o }),
      ...r,
      children: [
        s && /* @__PURE__ */ i("title", { children: s }),
        /* @__PURE__ */ i(
          "path",
          {
            d: "M4.93218 17.6536C4.54165 18.0442 4.54165 18.6773 4.93218 19.0679C5.3227 19.4584 5.95586 19.4584 6.34639 19.0679L12.0001 13.4142L17.6586 19.0727C18.0491 19.4632 18.6823 19.4632 19.0728 19.0727C19.4633 18.6822 19.4633 18.049 19.0728 17.6585L13.4143 12L19.0762 6.33809C19.4667 5.94756 19.4667 5.3144 19.0762 4.92387C18.6856 4.53335 18.0525 4.53335 17.6619 4.92387L12.0001 10.5858L6.34694 4.93264C5.95641 4.54211 5.32325 4.54211 4.93272 4.93264C4.5422 5.32316 4.5422 5.95633 4.93272 6.34685L10.5858 12L4.93218 17.6536Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
export {
  C as DismissIcon,
  C as default
};
